const EyeIconSvg = () => {
  return (
    <svg
      width='18'
      height='18'
      viewBox='0 0 24 24'
      xmlns='http://www.w3.org/2000/svg'
      style={{cursor: 'pointer'}}
    >
      <path d='M12 5C5 5 1 12 1 12s4 7 11 7 11-7 11-7-4-7-11-7z' fill='#01070fff' />
      <circle cx='12' cy='12' r='3' fill='none' stroke='#ffffff' strokeWidth='2' />
    </svg>
  )
}

export default EyeIconSvg
